module.exports = __webpack_public_path__ + "static/media/heroku-logs.0b13aa65.png";